export function resolveBasePath(injected: string | null | undefined, fallback: string, apiSegment: string = ''): string {
  const root = (injected?.trim() || fallback).replace(/\/+$/, '');
  return apiSegment ? `${root}${apiSegment}` : root;
}
